export const baseUrl = process.env.REACT_APP_BLOG_API_URL || 'https://www.googleapis.com/blogger/v3/blogs/460807346859212205/posts';
export const apiKey = process.env.REACT_APP_BLOG_API_KEY || 'AIzaSyBqKzXCCGSnRfDLxIZ7R64sIv7L3KlzJ10';

function getBlogs(setBlogs, setLoading, fetchImages = false) {
  const url = `${baseUrl}?key=${apiKey}&maxResults=7${fetchImages ? '&fetchImages=true' : ''}`;

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      const items = data.items || [];
      setBlogs(items);
      setLoading(false);
    })
    .catch((error) => {
    })
    .finally(() => {
      setLoading(false);
    });
}

function getBlog(postId, setBlog, setLoading, fetchImages = false) {
  const url = `${baseUrl}/${postId}?key=${apiKey}${fetchImages ? '&fetchImages=true' : ''}`;

  console.log('asdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdfasdf');
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      console.log('Fetched blog data:', data);
      setBlog(data);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
}

function extractImageFromContent(htmlContent) {
  const imgRegex = /<img[^>]+src="([^">]+)"/;
  const match = htmlContent.match(imgRegex);
  return match ? match[1] : null;
};

// extract html content
// used on actual News Pages
function getHTMLContent(html) {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  const extractedImage = extractImageFromContent(html);
  if (extractedImage) {
    tmp.querySelectorAll(`img[src="${extractedImage}"]`).forEach(el => el.remove());
  }

  // Remove empty divs left behind after image extraction
  tmp.querySelectorAll("div").forEach(el => {
    if (!el.textContent.trim()) el.remove();
  });

  // Remove empty anchor tags (no text, no img)
  tmp.querySelectorAll("a").forEach(el => {
    if (!el.textContent.trim() && !el.querySelector("img")) el.remove();
  });

  // Remove all styles
  tmp.querySelectorAll("[style]").forEach(el => el.removeAttribute("style"));

  // Remove empty or &nbsp;-only paragraphs
  tmp.querySelectorAll("p").forEach(el => {
    const isEmpty = !el.innerHTML.trim() || el.innerHTML.trim() === "&nbsp;";
    if (isEmpty) el.remove();
  });

  // Remove leading and trailing <br>s inside EVERY element
  [tmp, ...tmp.querySelectorAll("*")].forEach(el => {
    while (el.firstChild?.nodeName === "BR") el.firstChild.remove();
    while (el.lastChild?.nodeName === "BR") el.lastChild.remove();
  });

  return tmp.innerHTML;
}

// Used to extract text content for previews,
// Used on SmallNews Component, on News Listing Page
function getPreviewContent(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.innerText.replace(/&nbsp;/g, ' ').match(/^.*?[.!?]+/)?.[0].trim() || tmp.textContent.replace(/&nbsp;/g, ' ').match(/^.*?[.!?]+/)?.[0].trim() || "";
};

export { getBlogs, getBlog, extractImageFromContent, getHTMLContent, getPreviewContent };
